import { UnstyledButton } from '@mantine/core';
import { openModal } from '@mantine/modals';
import { PropsWithChildren, useMemo } from 'react';

import { useBot } from '@mygpt/app/bot';
import { transferToHumanAction } from '@mygpt/app/chat/services';

export const TransferToHuman = ({
  children,
  messageId,
  pageSource,
  sessionId,
}: PropsWithChildren<{ pageSource: string; messageId: string; sessionId: string }>) => {
  const { robotInfo } = useBot();

  const configs = useMemo(() => {
    return robotInfo?.configs;
  }, [robotInfo]);

  const subject_name = useMemo(() => {
    return robotInfo?.subject_name || '';
  }, [robotInfo]);

  const scriptSrcHost = window.location.host;
  const isDev = ['dev', 'localhost'].some((key) => scriptSrcHost.includes(key));

  const isWidget = useMemo(() => {
    return pageSource === 'widget' ? true : false;
  }, [pageSource]);

  const handleTransferToHuman = () => {
    if (!messageId || !robotInfo) return;
    transferToHumanAction({ ai_id: robotInfo.id, message_id: messageId });
    openModal({
      withinPortal: false,
      centered: true,
      radius: 'md',
      size: `${isWidget ? 400 : 800}`,
      children: <GoogleForm />,
    });
  };

  const GoogleForm = () => {
    if (!configs || !configs.transfer_to_human) return null;

    const host = isDev ? 'https://admin-dev.gbase.ai' : 'https://admin.gbase.ai';
    const sessionLink = `${host}/bot/${robotInfo?.id}/records?sessionId=${sessionId}`;

    const originalURL = configs.transfer_to_human.url;
    const url = new URL(originalURL);

    url.searchParams.set(configs.transfer_to_human.name_key, subject_name);
    url.searchParams.set(configs.transfer_to_human.session_key, sessionLink);
    url.searchParams.set('embedded', 'true');

    const formURL = url.toString();

    return (
      // eslint-disable-next-line jsx-a11y/iframe-has-title
      <iframe
        src={formURL}
        width={`${isWidget ? 375 : 780}`}
        height={`${isWidget ? 500 : 600}`}
        frame-border="0"
        margin-height="0"
        margin-width="0"
      >
        loading...
      </iframe>
    );
  };

  return (
    <UnstyledButton onClick={handleTransferToHuman} className="text-[0] w-full">
      {children}
    </UnstyledButton>
  );
};
